Greenmile.RouteSummary = Greenmile.RouteSummary || {};
Greenmile.RouteSummary.DamagedSKUs = Greenmile.RouteSummary.DamagedSKUs || {};
Greenmile.RouteSummary.DamagedSKUs.Grid = Greenmile.RouteSummary.DamagedSKUs.Grid || {};

Greenmile.RouteSummary.DamagedSKUs.Grid = (function () {
  /**
   * @constructor
   */
  function Grid () {

      Greenmile.RouteSummary.SKUs.Grid.apply(this, arguments);

      this.entity = 'RouteSummaryDamagedStock';

      this.containerGrid = "#RouteSummary #routeStockSummary #grid_damaged";
      this.gridActionsSelector = "#RouteSummary #routeStockSummary .gridActions_damaged";
      this.entityToActionGrid = 'RouteSummaryDamagedStock';
      this.countCustomColumns = 0;
  }

  return Grid;

}());